import {
  GiftOutlined,
  BulbOutlined,
  AreaChartOutlined,
  CommentOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  NotificationOutlined,
  StarOutlined,
  UserAddOutlined,
  UserSwitchOutlined,
  SolutionOutlined,
  RocketOutlined,
  FundProjectionScreenOutlined,
  TrophyOutlined,
  FileDoneOutlined,
  SettingOutlined,
  CalendarOutlined,
  CarOutlined,
  CheckOutlined,
  AuditOutlined,
  RobotOutlined,
  AudioOutlined,
  QrcodeOutlined,
  FormOutlined,
  NotificationFilled,
  TeamOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, ReadServices } from "configs/AppConfig";


const userengagementdashboardNavTree = [
  {
    key: "userengagementdashboard",
    path: `${APP_PREFIX_PATH}/userengagementdashboard`,
    title: "Engagement Dashboard",
  
    icon: UserSwitchOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const vouchersNavTree = [
  {
    key: "vouchers",
    path: `${APP_PREFIX_PATH}/vouchers`,
    title: "Vouchers",
    icon: GiftOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const gamesNavTree = [
  {
    key: "games",
    path: `${APP_PREFIX_PATH}/games`,
    title: "Games",
    icon: RocketOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const tniFormNavTree = [
  {
    key: "tniForm",
    path: `${APP_PREFIX_PATH}/tniForm`,
    title: "TNI Forms",
    icon: FormOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const annualCalender = [
  {
    key: "annualcalendar",
    path: `${APP_PREFIX_PATH}/annualtrainingcalendar`,
    title: "Annual Training Calendar",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const elearningNavTree = [
  {
    key: "elearning",
    path: `${APP_PREFIX_PATH}/elearning`,
    title: "LMS",
    icon: BulbOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const podCastNavTree = [
  {
    key: "podcast",
    path: `${APP_PREFIX_PATH}/podcast`,
    title: "Podcast",
    icon: AudioOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const lmscopilotNavTree = [
  {
    key: "lmscopilot",
    path: `${APP_PREFIX_PATH}/lmscopilot`,
    title: "LMS Copilot",
    icon: RobotOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const performancemetricsNavTree = [
  {
    key: "performance",
    path: `${APP_PREFIX_PATH}/performance`,
    title: "Performance",
    icon: AreaChartOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const incentivemtricsNavTree = [
  {
    key: "incentives",
    path: `${APP_PREFIX_PATH}/incentive`,
    title: "Incentives",
    icon: FundProjectionScreenOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const spotRewardNavTree = [
  {
    key: "spotRewards",
    path: `${APP_PREFIX_PATH}/spotreward`,
    title: "Spot Rewards",
    icon: TrophyOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const starperformanceNavTree = [
  {
    key: "starperformers",
    path: `${APP_PREFIX_PATH}/starperformers`,
    title: "Star Performers",
    icon: StarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const creditcoinNavTree = [
  {
    key: "creditcoins",
    path: `${APP_PREFIX_PATH}/creditcoins`,
    title: "Credit Coins",
    icon: DollarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const feedbackNavTree = [
  {
    key: "surveys",
    path: `${APP_PREFIX_PATH}/surveys`,
    title: "Surveys",
    icon: CommentOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const announcementsNavTree = [
  {
    key: "announcements",
    path: `${APP_PREFIX_PATH}/announcements`,
    title: "Announcements",
    icon: NotificationOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const eventsNavTree = [
  {
    key: "events",
    path: `${APP_PREFIX_PATH}/events`,
    title: "Events",
    icon: NotificationFilled,
    breadcrumb: false,
    submenu: [],
  },
];

const checklistsNavTree = [
  {
    key: "checklists",
    path: `${APP_PREFIX_PATH}/checklists`,
    title: "Checklists",
    icon: FileDoneOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const assetrequestNavTree = [
  {
    key: "assetrequest",
    path: `${APP_PREFIX_PATH}/assetrequest`,
    title: "Asset Request",
    icon: AuditOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const assetapproveNavTree = [
  {
    key: "assetapprove",
    path: `${APP_PREFIX_PATH}/assetapprove`,
    title: "Asset Approve",
    icon: CheckOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const assetmanagerNavTree = [
  {
    key: "assetmanager",
    path: `${APP_PREFIX_PATH}/assetmanager`,
    title: "Asset Manager",
    icon: CarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const qrReprotNavTree = [
  {
    key: "qrreport",
    path: `${APP_PREFIX_PATH}/qrreports`,
    title: "QR Reports",
    icon: QrcodeOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const leavesNavTree = [
  {
    key: "leave",
    path: `${APP_PREFIX_PATH}/leave`,
    title: "Leave",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const attendanceNavTree = [
  {
    key: "attendance",
    path: `${APP_PREFIX_PATH}/attendance`,
    title: "Attendance",
    icon: UserSwitchOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const employeesNavTree = [
  {
    key: "employeeupload",
    path: `${APP_PREFIX_PATH}/employees`,
    title: "Employees",
    icon: UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const userAccessPermissionNavTree = [
  {
    key: "userAccessPermission",
    path: `${APP_PREFIX_PATH}/permissions`,
    title: "Permissions",
    icon: UserAddOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const taskNavTree = [
  {
    key: "taskbox",
    path: `${APP_PREFIX_PATH}/taskbox`,
    title: "Task Box",
    icon: UnorderedListOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const coinHistoryNavTree = [
  {
    key: "coinHistory",
    path: `${APP_PREFIX_PATH}/coinhistory`,
    title: "Coin History",
    icon: SolutionOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const settingsNavTree = [
  {
    key: "settings",
    path: `${APP_PREFIX_PATH}/settings`,
    title: "Store Settings",
    icon: SettingOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const holidaysNavTree = [
  {
    key: "holidays",
    path: `${APP_PREFIX_PATH}/holidays`,
    title: "Holidays",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const servicedeskNavTree = [
  {
    key: "servicedesk",
    path: `${APP_PREFIX_PATH}/servicedesk`,
    title: "Service Desk",
    icon: CalendarOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfig = [

  ...(ReadServices?.includes("all") || ReadServices?.includes("userengagementdashboard")
    ? userengagementdashboardNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("vouchers")
    ? vouchersNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("games")
    ? gamesNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("tniForm")
    ? tniFormNavTree
    : []),

  ...(ReadServices?.includes("all") ||
  ReadServices?.includes("annualtrainingcalendar")
    ? annualCalender
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("elearning")
    ? elearningNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("podcast")
    ? podCastNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("lmscopilot")
    ? lmscopilotNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("performance")
    ? performancemetricsNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("incentive")
    ? incentivemtricsNavTree
    : []),
  ...(ReadServices?.includes("all") || ReadServices?.includes("spotreward")
    ? spotRewardNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("starperformers")
    ? starperformanceNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("holidays")
    ? holidaysNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("creditcoins")
    ? creditcoinNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("surveys")
    ? feedbackNavTree
    : []),
  // ...(ReadServices?.includes("all") || ReadServices?.includes("activity")
  //   ? activityNavTree
  //   : []),
  ...(ReadServices?.includes("all") || ReadServices?.includes("announcements")
    ? announcementsNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("events")
    ? eventsNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("checklists")
    ? checklistsNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("assetapprove")
    ? assetapproveNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("assetrequest")
    ? assetrequestNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("assetmanager")
    ? assetmanagerNavTree
    : []),
  ...(ReadServices?.includes("all") || ReadServices?.includes("qrreports")
    ? qrReprotNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("leave")
    ? leavesNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("attendance")
    ? attendanceNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("employees")
    ? employeesNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("permissions")
    ? userAccessPermissionNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("taskbox")
    ? taskNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("coinhistory")
    ? coinHistoryNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("settings")
    ? settingsNavTree
    : []),

  ...(ReadServices?.includes("all") || ReadServices?.includes("servicedesk")
    ? servicedeskNavTree
    : []),
];

export default navigationConfig;
